import { SuperInputBaseProps } from "@components:SuperInput/types";
import { Box, Tooltip } from "@mui/material";
import { IoMdHelpCircle } from "react-icons/io";

export const SuperInputBase = ({
  label,
  helperText,
  errorText,
  explainText,
  sx,
  required,
  children,
  autoHeight = true,
}: SuperInputBaseProps) => {
  return (
    <Box
      className="SuperInput"
      sx={{
        ...sx,
      }}
    >
      {label && (
        <Box
          sx={{
            display: "flex",
            gap: "5px",
            alignItems: "center",
          }}
        >
          <Box
            className="SuperInput__label"
            component="label"
            sx={{
              display: "block",
              fontSize: "0.875rem",
              fontWeight: "500",
              lineHeight: "1.5rem",
            }}
          >
            {label}
            {required && (
              <Box
                component="span"
                sx={{
                  marginLeft: "0.1rem",
                }}
              >
                *
              </Box>
            )}
          </Box>
          {explainText && (
            <Tooltip title={explainText} placement="right">
              <IoMdHelpCircle />
            </Tooltip>
          )}
        </Box>
      )}
      <Box
        sx={{
          marginTop: label ? "0.2rem" : undefined,
        }}
      >
        {children}
      </Box>
      <Box
        className="SuperInput__helperText"
        sx={{
          fontSize: "0.75rem",
          color: errorText ? "red" : "rgb(71, 85, 105)",
          marginTop: helperText || errorText ? "0.5rem" : undefined,
          visibility: helperText || errorText ? "visible" : "hidden",
          minHeight: autoHeight ? "12px" : undefined,
        }}
      >
        {helperText ?? errorText}
      </Box>
    </Box>
  );
};
